module.exports = __webpack_public_path__ + "static/motion-simulation-light-65beff8f8a1b474a96f1d4766ae278eb.svg";